export const getUrlSearchParam = (url: string, searchParam: string) => {
  const urlObj = new URL(url)

  return urlObj.searchParams.get(searchParam)
}
